import { Component } from '@angular/core';

@Component({
  selector: 'medrecord-auth-success-restored',
  templateUrl: './success-password-set.component.html',
})
export class SuccessPasswordSetComponent {}
